export enum SearchResultType {
  DEAL = "deal",
  STORE = "store",
}
